import axios from 'axios'

export default class Api_Usermanagement_V2 {
  constructor() {
    if (localStorage.getItem('token') != null) {
      this.api_token = localStorage.getItem('token')
    } else {
      this.api_token = ''
    }
    this.client = null
    this.api_url = process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT_V2
  }
  init = (use_token = true) => {
    let headers = {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    }
    headers = {
      ...headers,
      // Authorization: `Bearer ${this.api_token}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
    }
    this.client = axios.create({baseURL: this.api_url, headers: headers})
    return this.client
  }
}
